import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 17.66 17.65' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='general_content' data-name='general content'>
        <path
          className='cls-1'
          transform='rotate(-45 14.287 3.372)'
          d='M12.45.44h3.67v5.88h-3.67z'
        />
        <path
          className='cls-1'
          d='M14.03 7.79L9.86 3.63l-8.82 8.82L0 17.65l5.2-1.04 8.83-8.82z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/EditIcon.js